const baseRoute = 'resource-manager/:moduleBridgeHex/';
export default {
  // user_module_resourceManager_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //   },
  // },
  user_module_resourceManager_resource_home: {
    path: `${baseRoute}home/resource/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_resourceManager_obligation_home: {
    path: `${baseRoute}home/obligation/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_resourceManager_calendar: {
    path: `${baseRoute}calendar/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_resourceManager_settings_resourceTemplate_list: {
    path: `${baseRoute}settings/resource-template/list/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_resourceManager_settings_resourceTemplate_add: {
    path: `${baseRoute}settings/resource-template/:templateHex/add/`,
    parameters: {
      moduleBridgeHex: undefined,
      templateHex: undefined,
    },
  },
  user_module_resourceManager_settings_resourceTemplate_clone: {
    path: `${baseRoute}settings/resource-template/:templateHex/clone/`,
    parameters: {
      moduleBridgeHex: undefined,
      templateHex: undefined,
    },
  },
  user_module_resourceManager_settings_internalObligations: {
    path: `${baseRoute}settings/obligations/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_resourceManager_settings_internalObligation_home: {
    path: `${baseRoute}settings/obligation/:obligationHex`,
    parameters: {
      moduleBridgeHex: undefined,
      obligationHex: undefined,
    },
  },
};
